import React from "react";
import {
    Navigate,
} from "react-router-dom";

const BranchListComponent = React.lazy(() => import("../../../../../components/branches/components/list/page"));
const BranchAddComponent = React.lazy(() => import("../../../../../components/branches/components/add/page"));

export const branchRoute = [
    {
        path: 'list',
        element: <BranchListComponent />
    },
    {
        path: 'add',
        element: <BranchAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/stockify/branches/add" />
    },
    {
        path: 'edit/:id',
        element: <BranchAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/stockify/branches/list" />
    },
];